import { Grid } from "@mui/material";
import { BARRIOS_COMUNAS, ESTADOS_PROPIEDAD } from "../../utils/constants";
import { getPreguntasPaginadas } from "../../action";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";

const FiltroPreguntas = ({
  page,
  rowsPerPage,
  sortBy,
  filtroValues,
  setFiltroValues,
  buscador,
  storageKeyPrefix,
}) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.app.itemUsuario);
  const brokers = useSelector((state) => state.app.usuariosFiltrados);
  const preguntas = useSelector(
    (state) =>
      state.app.preguntasPaginadas
  );
  const handleSubmit = (formValues) => {
    localStorage.setItem(`${storageKeyPrefix}tipoOperacion`, formValues.tipoOperacion);
    localStorage.setItem(`${storageKeyPrefix}tipoPropiedad`, formValues.tipoPropiedad);
    localStorage.setItem(`${storageKeyPrefix}comuna`, formValues.comuna);
    localStorage.setItem(`${storageKeyPrefix}codigoPropiedad`, formValues.codigoPropiedad);
    localStorage.setItem(`${storageKeyPrefix}idBroker`, formValues.idBroker);
    localStorage.setItem("filtroEstado", formValues.estado);

    setFiltroValues(formValues);
    dispatch(
      getPreguntasPaginadas(
        formValues.idBroker,
        page,
        rowsPerPage,
        "todos",
        sortBy,
        formValues.comuna,
        formValues.tipoPropiedad,
        formValues.tipoOperacion,
        formValues.codigoPropiedad,
        "",
        buscador,
        formValues.estado
      )
    );
  };

  const limpiarFiltros = (formValues) => {
    localStorage.setItem(`${storageKeyPrefix}tipoOperacion`, "");
    localStorage.setItem(`${storageKeyPrefix}tipoPropiedad`, "");
    localStorage.setItem(`${storageKeyPrefix}comuna`, "");
    localStorage.setItem(`${storageKeyPrefix}codigoPropiedad`, "");
    localStorage.setItem("filtroEstado", "");
    localStorage.setItem(`${storageKeyPrefix}idBroker`, "");
    setFiltroValues(formValues);
    dispatch(
      getPreguntasPaginadas(
        "",
        1,
        rowsPerPage,
        "todos",
        sortBy,
        "",
        "",
        "",
        "",
        "",
        ""
      )
    );
  };


  let comunasOptions = [];
  if (window.location.pathname.includes("otras")) {
    Object.keys(BARRIOS_COMUNAS).forEach((c) =>
      comunasOptions.push({ value: c, label: c })
    );
  } else {
    Object.keys(BARRIOS_COMUNAS).forEach((c) =>
      comunasOptions.push({ value: c, label: c })
    );
    //comunas && comunas.size > 0 && comunas.forEach((c) => comunasOptions.push({value: c, label: c}));
  }

  comunasOptions.sort(function (a, b) {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  });

  const handleReset = (formValues) => {
    limpiarFiltros(formValues);
  };

  return (
    <div style={{ marginBottom: "10px" }}>
      <Formik
        initialValues={filtroValues}
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        {({ values, handleSubmit, handleReset }) => (
          <Form onSubmit={handleSubmit} onReset={handleReset}>
            <Grid container spacing={1} justifyContent={"space-between"}>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Operación</label>
                <Field name="tipoOperacion" as="select" className="miSelect">
                  <option value={""}>- Seleccione -</option>
                  <option value="arriendo">Arriendo</option>
                  <option value="venta">Venta</option>
                </Field>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Tipo inmueble</label>
                <Field name="tipoPropiedad" as="select" className="miSelect">
                  <option value={""}>- Seleccione -</option>
                  <option value="Departamento">Departamento</option>
                  <option value="Casa">Casa</option>
                </Field>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Comuna</label>
                <Field name="comuna" as="select" className="miSelect">
                  <option value={""}>- Seleccione -</option>
                  <optgroup label="Región metropolitana">
                    {comunasOptions
                      .filter(
                        (b) =>
                          b.label != "Quilpué" && b.label != "Villa Alemana"
                      )
                      .map((c) => (
                        <option value={c.value}>{c.label}</option>
                      ))}
                  </optgroup>
                  <optgroup label="Región de Valparaíso">
                    {comunasOptions
                      .filter(
                        (b) =>
                          b.label == "Quilpué" || b.label == "Villa Alemana"
                      )
                      .map((c) => (
                        <option value={c.value}>{c.label}</option>
                      ))}
                  </optgroup>
                </Field>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Código propiedad</label>
                <Field
                  name="codigoPropiedad"
                  type="text"
                  className="miSelect"
                />
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Estado</label>
                <Field name="estado" as="select" className="miSelect">
                  <option value={""}>- Seleccione -</option>
                  <option value="answered">Respondida</option>
                  <option value="unanswered">Pendiente</option>
                  <option value="closed_unanswered">Cerrada sin respuesta</option>
                  <option value="under_review">En revisión</option>
                  <option value="Whatsapp">Contacto</option>
                </Field>
              </Grid>
              {userData &&
                userData.tipoCuenta !== 10 &&
                window.location.pathname.includes("PreguntasPortalInmobiliario") && (
                  <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                    <label className="milabel">Broker</label>
                    <Field name="idBroker" as="select" className="miSelect">
                      <option value={""}>- Seleccione -</option>
                      {brokers &&
                        brokers.length > 0 &&
                        brokers.map((c) => (
                          <option value={c.id}>
                            {c.nombres} {c.apellidos}
                          </option>
                        ))}
                    </Field>
                  </Grid>
                )}
              <Grid item>
                <button
                  type="submit"
                  className="boton2"
                  style={{ margin: "10px" }}
                //onClick={() => filtrar()}
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  className="boton-gris"
                  style={{ margin: "10px" }}
                  onClick={(e) => handleReset(e)}
                >
                  Limpiar filtros
                </button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FiltroPreguntas;
